import { gql } from "@/services/httpAdapter.ts";

const CitExportHistoryFragment = gql`
	fragment CitExportHistory on CitExportHistory {
		_id
		exportedOn
		exportedBy
		exportType
	}
`;

const CitActivityExportHistoryFragment = gql`
	fragment CitActivityExportHistory on CitActivityExportHistory {
		_id
		exportedOn
		exportedBy
		exportType
		balance
		snapshotHierarchy {
			parent
			children
		}
	}
`;

const CitActivityFragment = gql`
	fragment CitActivity on CitActivity {
		_id
		recId
		locationId
		commissionCycleId
		payPeriodId
		age
		date
		fIDate
		account
		control
		controlType
		stockNumber
		customerNumber
		customerName
		dealNumber
		vinNumber
		lender
		balance
		amountFinanced
		financeEmployee
		financeEmployeeId
		deskManager
		deskManagerId
		salesManager
		salesManagerEmployeeId
		salesEmployee
		salesEmployeeId
		tenDaySent
		stage
		trade
		description
		glDesc
		source
		referenceNumber
		transactionAmount
		transactionDate
		postingDate
		creationDate
		hierarchy
		reservesHierarchy
		activityType
		isExportable
		exported {
			exportedOn
			exportedBy
			balance
		}
		recommendedAction
		funded
	}
`;

export { CitExportHistoryFragment, CitActivityExportHistoryFragment, CitActivityFragment };
